import { Component, OnInit, Inject } from '@angular/core';
import { DialogComponentBase } from '@wephone-core-ui';
import { IFlexDialogConfig, Colors, DialogActionButton, ToastService, joiValidator, PhoneNumberValidator, DialogService, NoWhitespaceValidator } from '@wephone-utils';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { EntityManager } from '@wephone-core/wephone-core.module';
import { _tk, _ti } from '@wephone-translation';
import { NumberLocationEntity } from '@wephone-core/model/entity/number_location';
import { NumberLocationRepository } from '@wephone-core/model/repository/number_location';
import { NoHtmlAndCurlyBracesValidator } from '@wephone-utils/validator/no-html-and-curly-braces-validator';
import { XSSValidator } from '@wephone-utils/validator/xss-validator';


@Component({
  selector: 'app-number-location-edit',
  templateUrl: './number-location-edit.component.html',
  styleUrls: ['./number-location-edit.component.scss']
})
export class NumberLocationEditComponent extends DialogComponentBase implements OnInit {
  static modalConfig: IFlexDialogConfig = {
    size: 's'
  };

  dialogTitle = _tk('number_location.action.edit');
  dialogRightActions: DialogActionButton[] = [
    {
      label: _tk('public.apply'),
      action: () => {
        this.submit();
      },
      visible: () => {
        return true;
      },
      color: Colors.PRIMARY
    }
  ];
  form: FormGroup;
  numberLocationId: number;
  item: NumberLocationEntity;

  _cancelButton: DialogActionButton = {
    label: _tk('public.button.close'),
    action: () => {
      this.dismiss();
    }
  };

  constructor(
    private fb: FormBuilder,
    dialogRef: MatDialogRef<NumberLocationEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      item: NumberLocationEntity;
    },
    private em: EntityManager,
    public toast: ToastService
  ) {
    super(dialogRef);

    this.item = data.item;
    this.numberLocationId = this.item && this.item.id || null;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.initFormGroup();
  }

  initFormGroup(): void {
    this.form = this.fb.group({
      name: [
        this.item && this.item.name || '',
        [Validators.required, Validators.maxLength(128), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      road_number: [
        this.item && this.item.road_number,
        [Validators.maxLength(10), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      road_type: [
        this.item && this.item.road_type,
        [Validators.maxLength(32), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      road_name: [
        this.item && this.item.road_name,
        [Validators.maxLength(128), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      postal_code: [
        this.item && this.item.postal_code,
        [Validators.maxLength(10), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      city_name: [
        this.item && this.item.city_name,
        [Validators.maxLength(64), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      insee_code: [
        this.item && this.item.insee_code,
        [Validators.maxLength(20), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
    });
  }

  async submit(): Promise<void> {
    try {
      if (!this.form.valid) {
        // console.error('Form is invalid', this.form);
        this.form.markAllAsTouched();
        throw new Error(_ti('public.message.data_invalid'));
      }

      const repo = this.em.getRepository<NumberLocationRepository>('NumberLocationRepository');
      const numberLocation: NumberLocationEntity = repo.create(_.extend(this.form.value, {
        enterprise_id: this.item.enterprise_id,
        is_default: this.item.is_default
      })) as NumberLocationEntity;

      let resp;
      if (this.numberLocationId) {
        _.extend(numberLocation, {
          id: this.numberLocationId,
        });

        resp = await repo.update(numberLocation);
        this.showInfo(_ti('public.message.update_success'));
      } else {
        resp = await repo.createAndSave(numberLocation);
        this.showInfo(_ti('public.message.create_success'));
      }

      console.log('Create/Update number location', resp);
      this.dismiss(resp, false);
    } catch (error) {
      console.error('Create number location failure', error);
      this.showErrorMessage(error, this.numberLocationId ? _ti('public.message.update_failure') : _ti('public.message.create_failure'));
    }
  }

  removeControlValue(controlName: string): void {
    this.form.get(controlName).markAsDirty();
    this.form.get(controlName).setValue(null);
  }
}
